import { Router } from '@angular/router';
import Swal  from 'sweetalert2';
import { HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthenticationService } from '../services/authentication/authentication.service';



@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(
    private authenticationService: AuthenticationService,
    private router:Router) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<any> {
    const currentUser = this.authenticationService.currentUserValue;
    return next.handle(request).pipe(
      catchError((err) => {
        let msg:string = JSON.stringify(err.error);
        if (err.status === 401) {
          this.authenticationService.logout();
          if(!msg)
          msg = 'A sessão expirou! Faça o login novamente! '
        }else if(err.status === 415){
          msg = 'Tipo da imagem não suportada';
          Swal.fire('Erro',msg,'error');
        }else if(currentUser == undefined){
          this.router.navigate(['/login']);
        }
        //console.log/"ERRO NO INTERCEPTOR ==> "+ err.error)
        Swal.fire('Erro',msg,'error');
          

        const error = err.error.message || err.statusText;
        
        return throwError(error);
      })
    );
  }
}
